module.exports = __webpack_public_path__ + "img/error-payment-method.d411c17.svg";